import { TIER, Tier } from './tier';

export type TierLimits = {
  maxUsers: number;
  maxPublishedCourses: number;
  allowsBulkImport: boolean;
  canUpgrade: boolean;
};

export const TIER_LIMITS: Record<Tier, TierLimits> = {
  [TIER.FREE]: {
    maxUsers: 10,
    maxPublishedCourses: 1,
    allowsBulkImport: false,
    canUpgrade: true,
  },
  [TIER.BUSINESS]: {
    maxUsers: 200,
    maxPublishedCourses: 100,
    allowsBulkImport: true,
    canUpgrade: false,
  },
};
